import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import Chatbot from '../pages/Chatbot'
import Menu from '../components/menus/Menu'
import Sidebar from '../components/menus/Sidebar'
import BottomNav from '../components/menus/BottomNav'
import CabeceraMovil from '../components/menus/CabeceraMovil'
import { useAuth } from '../components/auth/useAuth'

export default function CommercialRouter() {
	const {clientauth} = useAuth()

	return (
		<div className="app-layout">
			<Sidebar/>
			<CabeceraMovil rol={clientauth?.rol ?? ""}/>
			<div className="app-content">
				<Menu />
				<div className="app-main">
					<Routes>
						<Route path="/dashboard" element={<Navigate to="chatbot" replace />} />
						<Route path="/chatbot" element={<Chatbot />} />
						<Route path="*" element={<NotFoundPage />} />
					</Routes>
				</div>
			</div>
			<BottomNav/>
		</div>
	)
}
